<button *ngIf="simple" class="layout-config-button config-link" type="button" (click)="toggleConfigSidebar()">
    <i class="pi pi-cog"></i>
</button>

<p-drawer [(visible)]="visible" (onHide)="layoutService.hideConfigSidebar()" position="right" [transitionOptions]="'.3s cubic-bezier(0, 0, 0.2, 1)'" styleClass="layout-config-sidebar w-80" header="Settings">
    <div class="flex flex-col gap-4">
        <div>
            <span class="text-lg font-semibold">Primary</span>
            <div class="pt-2 flex gap-2 flex-wrap">
                @for (primaryColor of primaryColors(); track primaryColor.name) {
                    <button
                        type="button"
                        [title]="primaryColor.name"
                        (click)="updateColors($event, 'primary', primaryColor)"
                        [ngClass]="{
                            'outline-primary': primaryColor.name === selectedPrimaryColor()
                        }"
                        class="cursor-pointer w-6 h-6 rounded-full flex flex-shrink-0 items-center justify-center p-0 outline-none outline-offset-1"
                        [style]="{
                            'background-color': primaryColor?.name === 'noir' ? 'var(--text-color)' : primaryColor?.palette?.['500']
                        }"
                    ></button>
                }
            </div>
        </div>

        <div>
            <span class="text-lg font-semibold">Surface</span>
            <div class="pt-2 flex gap-2 flex-wrap">
                @for (surface of surfaces; track surface.name) {
                    <button
                        type="button"
                        [title]="surface.name"
                        (click)="updateColors($event, 'surface', surface)"
                        class="cursor-pointer w-6 h-6 rounded-full flex flex-shrink-0 items-center justify-center p-0 outline-none outline-offset-1"
                        [ngClass]="{
                            'outline-primary': selectedSurface() ? selectedSurface() === surface.name : isDarkTheme() ? surface.name === 'zinc' : surface.name === 'slate'
                        }"
                        [style]="{
                            'background-color': surface?.palette?.['500']
                        }"
                    ></button>
                }
            </div>
        </div>

        <!-- 'Color Scheme' Section -->
        <div class="flex flex-col gap-2">
            <span class="text-lg font-semibold">Color Scheme</span>
            <p-selectbutton [(ngModel)]="darkTheme" [options]="themeOptions" optionLabel="name" optionValue="value" [allowEmpty]="false"></p-selectbutton>
        </div>

        <ng-container *ngIf="!simple">
            <div class="flex flex-col gap-2">
                <span class="text-lg font-semibold">Menu Type</span>
                <div class="flex flex-wrap flex-col gap-3">
                    <div class="flex">
                        <div class="flex items-center gap-2 w-1/2">
                            <p-radio-button name="menuMode" value="static" [(ngModel)]="menuMode"></p-radio-button>
                            <label for="static">Static</label>
                        </div>

                        <div class="flex items-center gap-2 w-1/2">
                            <p-radio-button name="menuMode" value="overlay" [(ngModel)]="menuMode"></p-radio-button>
                            <label for="overlay">Overlay</label>
                        </div>
                    </div>
                    <div class="flex">
                        <div class="flex items-center gap-2 w-1/2">
                            <p-radio-button name="menuMode" value="slim" [(ngModel)]="menuMode"></p-radio-button>
                            <label for="slim">Slim</label>
                        </div>
                        <div class="flex items-center gap-2 w-1/2">
                            <p-radio-button name="menuMode" value="slim-plus" [(ngModel)]="menuMode" inputId="slim-plus"></p-radio-button>
                            <label for="slim-plus">Slim+</label>
                        </div>
                    </div>
                    <div class="flex">
                        <div class="flex items-center gap-2 w-1/2">
                            <p-radio-button name="menuMode" value="reveal" [(ngModel)]="menuMode"></p-radio-button>
                            <label for="reveal">Reveal</label>
                        </div>
                        <div class="flex items-center gap-2 w-1/2">
                            <p-radio-button name="menuMode" value="drawer" [(ngModel)]="menuMode" inputId="drawer"></p-radio-button>
                            <label for="drawer">Drawer</label>
                        </div>
                    </div>
                    <div class="flex">
                        <div class="flex items-center gap-2 w-1/2">
                            <p-radio-button name="menuMode" value="horizontal" [(ngModel)]="menuMode"></p-radio-button>
                            <label for="horizontal">Horizontal</label>
                        </div>
                    </div>
                </div>
            </div>

            <div class="flex flex-col gap-2">
                <span class="text-lg font-semibold">Menu Profile</span>
                <div class="flex flex-wrap flex-col gap-3">
                    <div class="flex">
                        <div class="flex items-center gap-2 w-1/2">
                            <p-radio-button name="menuProfilePosition" value="start" [(ngModel)]="menuProfilePosition"></p-radio-button>
                            <label for="start">Start</label>
                        </div>

                        <div class="flex items-center gap-2 w-1/2">
                            <p-radio-button name="menuProfilePosition" value="end" [(ngModel)]="menuProfilePosition"></p-radio-button>
                            <label for="end">End</label>
                        </div>
                    </div>
                </div>
            </div>

            <div class="flex flex-col gap-2">
                <span class="text-lg font-semibold">Menu Themes</span>
                <p *ngIf="isDarkTheme(); else menu_theme_selector">Menu themes are only available in light mode by design as large surfaces can emit too much brightness in dark mode.</p>
                <ng-template #menu_theme_selector>
                    <div class="pt-2 flex gap-2 flex-wrap">
                        @for (theme of menuThemes; track theme) {
                            <button
                                type="button"
                                class="cursor-pointer w-6 h-6 rounded-full flex flex-shrink-0 items-center justify-center p-0 outline-none outline-offset-1 shadow"
                                (click)="changeMenuTheme(theme.name)"
                                [ngStyle]="{ 'background-color': theme.color }"
                            >
                                <i *ngIf="menuTheme === theme.name" class="pi pi-check text-lg" [ngClass]="{ 'text-white': menuTheme !== 'light' }"></i>
                            </button>
                        }
                    </div>
                </ng-template>
            </div>

            <div class="flex flex-col gap-2">
                <span class="text-lg font-semibold">Topbar Themes</span>
                <div class="pt-2 flex gap-2 flex-wrap">
                    @for (theme of topbarThemes; track theme) {
                        <button
                            type="button"
                            class="cursor-pointer w-6 h-6 rounded-full flex flex-shrink-0 items-center justify-center p-0 outline-none outline-offset-1 shadow"
                            (click)="changeTopbarTheme(theme.name)"
                            [ngStyle]="{ 'background-color': theme.color }"
                        >
                            <i *ngIf="topbarTheme === theme.name" class="pi pi-check text-lg" [ngClass]="{ 'text-white': topbarTheme !== 'light' }"></i>
                        </button>
                    }
                </div>
            </div>
        </ng-container>
    </div>
</p-drawer>